import React, {Component} from 'react';
import {connect} from 'react-redux';
import {map} from 'lodash';
import {Card, Table, Loader, Menu} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import UsersTable from './usersTable';
import UsersCreation from './userCreation';
import UserModification from './userModification';
import './styles.scss';

const types = {
  'create': 'CREACION',
  'modify': 'MODIFICACION',
};

const DisplayContent = (props) => {
  const {type} = props;
  if (type === 'modify') {
    return <UserModification {...props} />;
  }
  return <UsersCreation {...props} />;
};

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'user': null,
      'activeItem': 'create',
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.UsersList,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentWillUnmount() {
    this.props.clearUserList();
  }

  handleChange = (e, {value}) => {
    const userValue = value.toUpperCase();
    this.setState({'user': userValue});
  };

  handleItemClick = (idx) => {
    this.setState({'activeItem': idx});
  }

  renderLoaderOrUsers = () => {
    const {loading, list} = this.props;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return <UsersTable list={list} />;
  };

  render() {
    const {activeItem} = this.state;

    return (
      <div className="user-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Mantenimiento Usuarios</h2>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <Menu attached='top' color='red' tabular>
            {map(types, (type, idx) =>
              <Menu.Item
                key={idx}
                name={type}
                color='red'
                active={activeItem === idx}
                onClick={() => this.handleItemClick(idx)}
              />
            )}
          </Menu>
          <DisplayContent
            type={activeItem}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.usersList.loading,
    'list': state.usersList.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'dealerId': state.session.dealerId,
  };
};

const {clearUserList, navigateTo} = Actions;

export default connect(mapStateToProps, {
  clearUserList,
  navigateTo,
})(UsersList);
